module.exports = __webpack_public_path__ + "static/media/MEINPA_MENU-normal.98f0554d.png";